import React from "react";
import styles from "./ReadinessDropdowns.module.css";

/* Q7 (readiness) rendered as a row of dropdowns inside the fitting panel.
   value is the grouped answer map { [groupIndex]: option };
   onChange(questionId, option, groupIndex) reports each selection up. */
const ReadinessDropdowns = ({ question, value, onChange }) => (
  <div className={styles.dropRow}>
    {question.groups.map((group, gi) => (
      <div className={styles.field} key={gi}>
        <label className={styles.label} htmlFor={`pa-readiness-${gi}`}>
          {group.label}
        </label>
        <select
          id={`pa-readiness-${gi}`}
          className={`${styles.input} ${styles.select}`}
          value={value?.[gi]?.label || ""}
          onChange={(e) => {
            const opt = group.options.find((o) => o.label === e.target.value) || null;
            onChange(question.id, opt, gi);
          }}
        >
          <option value="">Select…</option>
          {group.options.map((o) => (
            <option key={o.label} value={o.label}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
    ))}
  </div>
);

export default ReadinessDropdowns;
